import styled from 'styled-components';

export const Time = styled.span`
  font-weight: bold;
`;

export const Price = styled.span`
  font-weight: bold;
  font-size: 18px;
`;

export const Type = styled.span`
  font-weight: bold;
`;

export const RoundTrip = styled.span`
  color: ${(props) => props.theme.map.skip.background};
`;
